import type { IconDefaultProps } from './types'

const PlusIcon = ({ className, 'data-test': dataTest }: IconDefaultProps): JSX.Element => (
  <svg
    className={className}
    data-test={dataTest}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      fill='currentColor'
      d='M9.5 2C9.77614 2 10 2.22386 10 2.5V9H16.5C16.7761 9 17 9.22386 17 9.5C17 9.77614 16.7761 10 16.5 10H10L10 16.5C10 16.7761 9.77614 17 9.5 17C9.22386 17 9 16.7761 9 16.5L9 10H2.5C2.22386 10 2 9.77614 2 9.5C2 9.22386 2.22386 9 2.5 9H9L9 2.5C9 2.22386 9.22386 2 9.5 2Z'
    />
  </svg>
)

export default PlusIcon
